export default __webpack_public_path__ + "static/media/constructive-feedback.765daf9b.svg";